<script lang="ts">
  import type { TGetAssetsResult } from "../../../passport-evm/src/utils/types";
  import { resolveIPFS } from "./ipfs";

  export let asset: TGetAssetsResult[number];
  export let onSelect: (asset: TGetAssetsResult[number]) => void;
</script>

<div
  role="button"
  tabindex="0"
  onclick={() => onSelect(asset)}
  onkeydown={() => {}}
  class="crtw-flex crtw-flex-1 crtw-max-w-[120px] crtw-cursor-pointer"
>
  <div>
    <div
      class="crtx-flex crtw-h-[120px] crtw-aspect-square crtw-bg-[#B4A7D6] crtw-rounded-sm crtw-mb-4 crtw-overflow-hidden"
    >
      {#if asset.metadata?.image || asset.metadata?.image_url}
        <img
          src={resolveIPFS(asset.metadata?.image || asset.metadata?.image_url)}
          alt="Asset"
          class="crtw-w-full crtw-h-full crtw-object-cover"
        />
      {/if}
    </div>

    <div class="crtw-space-y-1">
      {#if asset.metadata?.price}
        <p class="crtw-text-xl crtw-font-bold crtw-text-gray-900">
          {asset.metadata?.price}
          <span
            class="crtw-text-[10px] crtw-text-gray-400 crtw-align-top crtw-uppercase"
          >
            usd
          </span>
        </p>
      {/if}

      {#if asset.metadata?.name}
        <h3 class="crtw-font-bold crtw-text-gray-800">
          {asset.metadata?.name}
        </h3>
      {/if}

      {#if asset.metadata?.description}
        <p class="crtw-text-xs crtw-text-gray-500 crtw-leading-tight">
          {asset.metadata?.description}
        </p>
      {/if}
    </div>
  </div>
</div>
